/* ============================================
   UNGER Distributeur - Theme JS v2
   Drawer, predictive search, variants, accordion, sticky ATC, toasts
   ============================================ */
(function() {
  'use strict';

  /* ---------- Money formatter ---------- */
  function formatMoney(value) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
  }

  /* ---------- Toast ---------- */
  function toast(message, type) {
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.className = 'toast toast--' + (type || 'success');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-visible'));
    setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => el.remove(), 300);
    }, 3000);
  }
  window.UngerToast = toast;

  /* ---------- HT/TTC toggle ---------- */
  function initVatToggle() {
    if (!window.theme || !window.theme.showVatToggle) return;
    const saved = localStorage.getItem('vatDisplay') ||
      (window.theme.customer && window.theme.customer.isB2B ? 'ht' : null) ||
      document.documentElement.getAttribute('data-default-vat') || 'ttc';
    applyVat(saved);
    document.querySelectorAll('[data-vat-toggle]').forEach(group => {
      group.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          const mode = btn.getAttribute('data-vat-mode');
          applyVat(mode);
          localStorage.setItem('vatDisplay', mode);
        });
      });
    });
  }
  function applyVat(mode) {
    const rate = (window.theme.vatRate || 20) / 100;
    document.body.setAttribute('data-vat-display', mode);
    document.querySelectorAll('[data-price-ht]').forEach(el => {
      const ht = parseFloat(el.getAttribute('data-price-ht'));
      if (isNaN(ht)) return;
      const val = mode === 'ttc' ? ht * (1 + rate) : ht;
      const target = el.querySelector('[data-price-display]') || el;
      target.textContent = formatMoney(val);
      const suffix = el.querySelector('[data-price-suffix]');
      if (suffix) suffix.textContent = mode === 'ttc' ? 'TTC' : 'HT';
    });
    document.querySelectorAll('[data-price-alt]').forEach(el => {
      const ht = parseFloat(el.getAttribute('data-alt-ht'));
      if (isNaN(ht)) return;
      el.textContent = mode === 'ttc' ? 'soit ' + formatMoney(ht) + ' HT' : 'soit ' + formatMoney(ht * (1 + rate)) + ' TTC';
    });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.querySelector('[data-site-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- Qty selector ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty-selector]').forEach(wrap => {
      if (wrap.dataset.bound) return; wrap.dataset.bound = '1';
      const input = wrap.querySelector('input[type="number"]');
      const minus = wrap.querySelector('[data-qty="minus"]');
      const plus = wrap.querySelector('[data-qty="plus"]');
      if (!input) return;
      minus && minus.addEventListener('click', () => {
        const v = Math.max(parseInt(input.min || 1), parseInt(input.value || 1) - 1);
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus && plus.addEventListener('click', () => {
        const max = parseInt(input.max || 9999);
        input.value = Math.min(max, parseInt(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const main = gallery.querySelector('[data-gallery-main] img');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(t => {
        t.addEventListener('click', () => {
          if (!main) return;
          main.src = t.getAttribute('data-full-src');
          thumbs.forEach(o => o.classList.remove('active'));
          t.classList.add('active');
        });
      });
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion] [data-accordion-header]').forEach(h => {
      h.addEventListener('click', () => {
        const item = h.closest('[data-accordion-item]');
        item.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Variant selector ---------- */
  function initVariantSelector() {
    document.querySelectorAll('[data-variant-form]').forEach(form => {
      const variantsData = form.getAttribute('data-variants');
      if (!variantsData) return;
      let variants;
      try { variants = JSON.parse(variantsData); } catch (e) { return; }
      const selectors = form.querySelectorAll('[data-variant-option]');
      const idInput = form.querySelector('input[name="id"]');
      const priceEl = form.querySelector('[data-price-ht]');
      const submitBtn = form.querySelector('[type="submit"]');
      const stockEl = form.querySelector('[data-stock-indicator]');

      function getSelected() {
        const groups = {};
        selectors.forEach(s => {
          if (s.classList.contains('active')) {
            const name = s.getAttribute('data-option-name');
            groups[name] = s.getAttribute('data-option-value');
          }
        });
        return groups;
      }

      function findVariant(selected) {
        return variants.find(v => {
          return Object.keys(selected).every(k => {
            const idx = parseInt(k);
            return v.options[idx] === selected[k];
          });
        });
      }

      function updateUI() {
        const selected = getSelected();
        const variant = findVariant(selected);
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          priceEl.setAttribute('data-price-ht', (variant.price / 100).toFixed(2));
          applyVat(localStorage.getItem('vatDisplay') || (window.theme.customer.isB2B ? 'ht' : 'ttc'));
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (window.theme.strings.addToCart || 'Ajouter au panier')
            : (window.theme.strings.soldOut || 'Épuisé');
        }
        if (stockEl) {
          if (variant.inventory_quantity > 5) {
            stockEl.className = 'product-info__stock product-info__stock--in';
            stockEl.textContent = 'En stock';
          } else if (variant.inventory_quantity > 0) {
            stockEl.className = 'product-info__stock product-info__stock--low';
            stockEl.textContent = `Plus que ${variant.inventory_quantity} en stock`;
          } else if (variant.available) {
            stockEl.className = 'product-info__stock product-info__stock--low';
            stockEl.textContent = 'Sur commande (5-7 jours)';
          } else {
            stockEl.className = 'product-info__stock product-info__stock--out';
            stockEl.textContent = 'Indisponible';
          }
        }
      }

      selectors.forEach(s => {
        s.addEventListener('click', () => {
          const name = s.getAttribute('data-option-name');
          form.querySelectorAll(`[data-option-name="${name}"]`).forEach(o => o.classList.remove('active'));
          s.classList.add('active');
          updateUI();
        });
      });
    });
  }

  /* ---------- Add to cart (AJAX + drawer) ---------- */
  function initAddToCart() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        try {
          const fd = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || 'Erreur');
          }
          await refreshCart();
          openDrawer();
          if (btn) { btn.textContent = '✓ Ajouté'; setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500); }
        } catch (err) {
          toast(err.message || 'Erreur lors de l\'ajout au panier', 'error');
          if (btn) { btn.textContent = original; btn.disabled = false; }
        }
      });
    });

    /* Quick add buttons on product cards */
    document.body.addEventListener('click', async e => {
      const btn = e.target.closest('[data-quickadd]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.getAttribute('data-quickadd');
      const original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Erreur');
        await refreshCart();
        openDrawer();
        btn.innerHTML = '✓';
        setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1200);
      } catch (err) {
        toast('Erreur lors de l\'ajout', 'error');
        btn.innerHTML = original; btn.disabled = false;
      }
    });
  }

  async function refreshCart() {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      renderDrawer(cart);
    } catch (e) {}
  }

  /* ---------- Cart drawer ---------- */
  function initDrawer() {
    document.body.addEventListener('click', e => {
      if (e.target.closest('[data-cart-drawer-open]')) {
        e.preventDefault();
        openDrawer();
      }
      if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-drawer-backdrop]')) {
        closeDrawer();
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
    refreshCart();
  }

  function openDrawer() {
    const d = document.querySelector('[data-cart-drawer]');
    const b = document.querySelector('[data-drawer-backdrop]');
    if (d) d.classList.add('is-open');
    if (b) b.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    const d = document.querySelector('[data-cart-drawer]');
    const b = document.querySelector('[data-drawer-backdrop]');
    if (d) d.classList.remove('is-open');
    if (b) b.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  function renderDrawer(cart) {
    const body = document.querySelector('[data-cart-drawer-body]');
    const footer = document.querySelector('[data-cart-drawer-footer]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Votre panier est vide.</p><a href="/collections/all" class="btn btn--ghost">Voir le catalogue</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = '';
    body.innerHTML = cart.items.map(item => {
      const img = item.image ? `<img src="${item.image.replace(/(\.[^.]+)$/, '_120x$1')}" alt="">` : '';
      return `
        <div class="cart-drawer__item" data-cart-item-key="${item.key}">
          <div class="cart-drawer__item-img">${img}</div>
          <div class="cart-drawer__item-info">
            <h4><a href="${item.url}">${item.product_title}</a></h4>
            <div class="cart-drawer__item-ref">${item.sku || ''}</div>
            <div class="cart-drawer__item-qty" data-qty-selector data-key="${item.key}">
              <button type="button" data-qty="minus" data-cart-update="${item.quantity - 1}">−</button>
              <input type="number" value="${item.quantity}" min="0" data-cart-qty-input>
              <button type="button" data-qty="plus" data-cart-update="${item.quantity + 1}">+</button>
            </div>
          </div>
          <div>
            <div class="cart-drawer__item-price">${formatMoney(item.final_line_price / 100)}</div>
            <button type="button" class="cart-drawer__remove" data-cart-remove="${item.key}">Retirer</button>
          </div>
        </div>
      `;
    }).join('');

    const subtotalEl = document.querySelector('[data-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price / 100);

    initQty();
  }

  /* Cart drawer update / remove */
  document.body.addEventListener('click', async e => {
    const updBtn = e.target.closest('[data-cart-update]');
    if (updBtn) {
      e.preventDefault();
      const item = updBtn.closest('[data-cart-item-key]');
      const key = item.getAttribute('data-cart-item-key');
      const qty = Math.max(0, parseInt(updBtn.getAttribute('data-cart-update'), 10));
      await updateItem(key, qty);
      return;
    }
    const rmBtn = e.target.closest('[data-cart-remove]');
    if (rmBtn) {
      e.preventDefault();
      const key = rmBtn.getAttribute('data-cart-remove');
      await updateItem(key, 0);
    }
  });

  async function updateItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCart();
    } catch (e) { toast('Erreur de mise à jour', 'error'); }
  }

  /* ---------- Predictive search ---------- */
  function initPredictive() {
    const trigger = document.querySelector('[data-search-trigger]');
    const panel = document.querySelector('[data-predictive-search]');
    if (!trigger || !panel) return;
    const input = panel.querySelector('input');
    const results = panel.querySelector('[data-predictive-results]');

    trigger.addEventListener('click', e => {
      e.preventDefault();
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) input.focus();
    });

    document.addEventListener('click', e => {
      if (!panel.contains(e.target) && !trigger.contains(e.target)) {
        panel.classList.remove('is-open');
      }
    });

    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      results.innerHTML = '<div class="predictive-loading">Recherche…</div>';
      timer = setTimeout(() => doSearch(q), 250);
    });

    async function doSearch(q) {
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag`;
        const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
        const data = await r.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          results.innerHTML = `<div class="predictive-empty">Aucun résultat pour « ${q} »</div>`;
          return;
        }
        results.innerHTML = products.map(p => {
          const img = p.image ? `<img src="${p.image.replace(/(\.[^.]+)$/, '_120x$1')}" alt="">` : '';
          return `
            <a href="${p.url}" class="predictive-result">
              <div class="predictive-result__img">${img}</div>
              <div class="predictive-result__body">
                <p class="predictive-result__title">${p.title.split(' – ')[0]}</p>
                <span class="predictive-result__ref">${p.vendor || ''} · ${p.variants?.[0]?.sku || ''}</span>
              </div>
              <div class="predictive-result__price">${formatMoney(parseFloat(p.price))}</div>
            </a>
          `;
        }).join('') + `<div style="text-align:center;margin-top:.75rem"><a href="/search?q=${encodeURIComponent(q)}" class="small">Voir tous les résultats →</a></div>`;
      } catch (e) {
        results.innerHTML = '<div class="predictive-empty">Erreur de recherche</div>';
      }
    }
  }

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  function initStickyATC() {
    const sticky = document.querySelector('[data-sticky-atc]');
    const ref = document.querySelector('[data-product-form]');
    if (!sticky || !ref) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => sticky.classList.toggle('is-visible', !en.isIntersecting));
    }, { threshold: 0 });
    io.observe(ref);
  }

  /* ---------- Mobile filter toggle ---------- */
  function initMobileFilter() {
    document.body.addEventListener('click', e => {
      if (e.target.closest('[data-mobile-filter-toggle]')) {
        const sb = document.querySelector('.collection-sidebar');
        if (sb) sb.classList.toggle('is-open');
      }
      if (e.target.closest('.collection-sidebar__close')) {
        const sb = document.querySelector('.collection-sidebar');
        if (sb) sb.classList.remove('is-open');
      }
    });
  }

  /* ---------- Facet group collapse ---------- */
  function initFacets() {
    document.querySelectorAll('.facet-group__title').forEach(t => {
      t.addEventListener('click', () => t.closest('.facet-group').classList.toggle('is-collapsed'));
    });
  }

  /* ---------- INIT ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initVatToggle();
    initMobileNav();
    initQty();
    initGallery();
    initAccordion();
    initVariantSelector();
    initAddToCart();
    initDrawer();
    initPredictive();
    initStickyATC();
    initMobileFilter();
    initFacets();
  });
})();
